import { render, staticRenderFns } from "./ImageUploadArea.vue?vue&type=template&id=4fa169bf&scoped=true"
import script from "./ImageUploadArea.vue?vue&type=script&lang=js"
export * from "./ImageUploadArea.vue?vue&type=script&lang=js"
import style0 from "./ImageUploadArea.vue?vue&type=style&index=0&id=4fa169bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa169bf",
  null
  
)

export default component.exports